import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { DateRangePicker, defaultStaticRanges } from "react-date-range";
import { addDays } from "date-fns";
import { Modal } from "react-bootstrap";

import "./DateRange.scss";

const DateRange = ({
	show,
	onCancel,
	onChange,
	customRanges,
	minDate,
	maxDate,
	startingDate,
	endingDate,
}) => {
	const { lang } = global;

	const [state, setState] = useState([
		{
			startDate: startingDate,
			endDate: endingDate,
			key: "selection",
		},
	]);

	const closeDateRange = () => {
		onCancel();
		setState([
			{
				startDate: startingDate,
				endDate: endingDate,
				key: "selection",
			},
		]);
	};

	const selectDateRange = () => {
		const [range] = state;
		const { startDate, endDate } = range;

		const value = {
			startDate: `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`,
			endDate: `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`,
		};
		onChange(value);
		closeDateRange();
	};

	useEffect(() => {
		setState([
			{
				startDate: !startingDate ? new Date() : new Date(startingDate),
				endDate: !endingDate ? new Date() : new Date(endingDate),
				key: "selection",
			},
		]);
	}, [startingDate, endingDate]);

	return (
		<Modal
			id="date-range-selector"
			show={show}
			onHide={closeDateRange}
		>
			<Modal.Body>
				<DateRangePicker
					onChange={item => setState([item.selection])}
					showSelectionPreview
					moveRangeOnFirstSelection={false}
					ranges={state}
					months={2}
					direction="horizontal"
					dateDisplayFormat="yyyy-MM-dd"
					staticRanges={customRanges || defaultStaticRanges}
					maxDate={maxDate}
					minDate={minDate}
				/>
			</Modal.Body>

			<Modal.Footer className="text-center">
				<button
					type="button"
					className="btn btn-primary"
					onClick={selectDateRange}
				>
					{lang.t("Ok")}
				</button>

				<button
					type="button"
					className="btn margin-left-12"
					onClick={closeDateRange}
				>
					{lang.t("Cancel")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

DateRange.propTypes = {
	show: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	customRanges: PropTypes.array,
	minDate: PropTypes.instanceOf(Date),
	maxDate: PropTypes.instanceOf(Date),
	startingDate: PropTypes.instanceOf(Date),
	endingDate: PropTypes.instanceOf(Date),
};

DateRange.defaultProps = {
	customRanges: null,
	minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
	maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
	startingDate: new Date(),
	endingDate: addDays(new Date(), 7),
};

export default DateRange;
